import { sendRequest } from "../../../services/office-api";
import { translations } from "../../../services/context";
import { createEffect } from "solid-js";

export default function HeaderRight(props) {
  const referralElement = "wrapper-referral-program";
  const referralTags = {
    view: {
      name: `${referralElement}-view`,
      type: "page-load"
    },
    click: {
      name: `${referralElement}-click`,
      type: "notice-content"
    },
    close: {
      name: `${referralElement}-close`,
      type: "close-icon"
    }
  }

  createEffect(() => {
    if (!props.hiddenElements()?.includes(referralElement) && props.isReferral()) {
      props.setShowReferralTooltip(true);
      trackReferralEvent("view");
    } else {
      props.setShowReferralTooltip(false);
    }
  })

  function trackReferralEvent(eventType) {
    fetch(`${process.env.INTELLIGENCE_URL}/action`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: referralTags[eventType].name,
        email: props.email,
        type: referralTags[eventType].type,
        value: '1',
        group: 'wrapper-notice'
      })
    });
  }

  const handleCloseTooltip = async (e) => {
    e.stopPropagation();
    props.setShowReferralTooltip(false);
    trackReferralEvent("close");

    const hidden = props.hiddenElements();
    if (!hidden?.includes(referralElement)) {
      const data = new URLSearchParams();
      data.append('element', referralElement);

      await sendRequest(props.token, `profile/hide-element`, {
        method: "POST",
        body: data
      });
    }
  };

  const handleReferralClick = (e) => {
    e.preventDefault();
    trackReferralEvent("click");
    window.open(props.link, props.target || '_self');
  };

  return (
    <>
      <div class="header-center-link associates-referral-element">
        <div class="header-referral-cta-area"
          onMouseEnter={() => props.setShowReferralTooltip(true)}
          onMouseLeave={() => props.setShowReferralTooltip(false)}
        >
          <button
            class="referral-cta-btn associates-referral-title"
            id="referral-associates-btn"
            onClick={handleReferralClick}
          >
            {props.title}
          </button>
          {(props.showReferralTooltip() && props.isReferral()) && (
            <div class="referral-tooltip-banner">
              <div class="referral-tooltip-content">
                <span innerHTML={translations['header-menu-referral-program']} />
                <span
                  onClick={handleReferralClick}
                  class="referral-tooltip-learn"
                  innerHTML={translations['learn-more']}
                />
              </div>
              <button
                class="referral-tooltip-close"
                onClick={handleCloseTooltip}
                aria-label="Close"
              >×</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
